﻿import { useMemo } from "react";
import { axiosInstance } from "../../utils";

export function useWageImportJobDownloadFileFn() {
    const axios = axiosInstance();

    return useMemo(
        () =>
            (
                clientId: string | undefined,
                fileType: "original" | "results",
                jobId: string,
                filename: string | undefined,
                progressCallback: (progress: number) => void
            ) =>
                axios
                    .get<Blob>(`api/clients/${clientId}/wagejobs/${jobId}/${fileType}`, {
                        responseType: "blob",
                        onDownloadProgress: progressEvent => {
                            const loaded = progressEvent.loaded;
                            const total = progressEvent.total;
                            if (total) {
                                const percentage = (loaded / total) * 100;
                                progressCallback(percentage);
                            }
                        },
                    })
                    .then(response => {
                        const contentDisposition = response.headers["content-disposition"];
                        let contentFilename;

                        if (contentDisposition) {
                            const match = contentDisposition.match(/filename="?([^"]+)"?/);

                            if (match) {
                                contentFilename = match[1];
                            }
                        }
                        return {
                            data: response.data,
                            filename: contentFilename || filename,
                        };
                    }),
        [axios]
    );
}
